import { CURRENCY_SYMBOLS } from "./currencymap.js";
import { formatNumber } from "./number.js";

export function getCurrencySymbolByCode(currencyCode) {
  const RTL_CURRENCY = ["BHD"];
  const symbol = CURRENCY_SYMBOLS[currencyCode] || currencyCode;

  /**
   * The Problem: Mixing RTL Scripts in LTR Mode
   * --------------------------------------------------
   * When a (RTL) currency symbol (like BHD: `.د.ب`) is used in a (LTR) environment,
   * the text rendering engine may incorrectly rearrange characters due to the way bidirectional text works.
   *
   * To prevent this issue, the Unicode Left-to-Right Override character (`\u202D`) is applied to force the correct visual order
   * when RTL currency symbols are mixed with LTR text.
   *
   * This fix is applied only in LTR mode and only for affected RTL currencies.
   * Reference Ticket ID: KF4-10453
   */
  const fixedSymbol =
    !window.isRTL && RTL_CURRENCY.includes(currencyCode)
      ? `\u202D${symbol}` // Force LTR rendering for RTL symbols
      : symbol;
  return fixedSymbol;
}

export function formatCurrency(value, decimal, locale) {
  if (!value) return null;
  const [currencyValue, currencyCode] = value.split(" ");
  const symbol = getCurrencySymbolByCode(currencyCode) || currencyCode;
  return `${symbol || ""}${formatNumber(currencyValue, decimal, locale)}`;
}
